@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'action') {
            @if (isLocked(element) || element.statusId == 1 || element.statusId == 3) {
              <div class="flex justify-center items-center gap-3">
                <div *ngIf="column.key.select" class="icon-btn">
                  @if (checkSelect(element)) {
                    @if (multiSelect) {
                      <mat-icon> check_box </mat-icon>
                    } @else {
                      <mat-icon> radio_button_checked </mat-icon>
                    }
                  } @else {
                    @if (multiSelect) {
                      <mat-icon> check_box_outline_blank </mat-icon>
                    } @else {
                      <mat-icon> radio_button_unchecked </mat-icon>
                    }
                  }
                </div>
              </div>
            }
          } @else if (column.keyColumn == 'viewItineraries') {
            <mat-icon
              class="btn-icon-outline"
              fontIcon="route"
              matTooltip="Itinerários"
              (click)="itinerariesItemEvent(element); $event.stopPropagation()"
            />
          } @else if (column.keyColumn == 'refuseRequest') {
            <!-- só dá para recusar enquanto a solicitação está Aberta ou em Cotação em Andamento -->
            @if (element.statusId == 1 || element.statusId == 3) {
              <mat-icon
                class="btn-icon-outline"
                fontIcon="block"
                matTooltip="Recusar solicitação"
                (click)="refuseItemEvent(element); $event.stopPropagation()"
              />
            }
          } @else if (column.keyColumn == 'phone') {
            {{ element[column.key] | telefone }}
          } @else if (column.keyColumn == 'cpf') {
            {{ element[column.key] | cpf }}
          } @else if (column.keyColumn == 'cnpj') {
            {{ element[column.key] | cnpj }}
          } @else if (column.keyColumn == 'location_OD') {
            <b>Origem: </b>{{ element.origem }}<br />
            <b>Destino: </b>{{ element.destino }}
          } @else if (column.keyColumn == 'servico_TS') {
            <b>Tipo: </b>{{ element.tipoServico }}<br />
            <b>Serviço: </b>{{ element.servico }}
          } @else if (column.keyColumn == 'vehicle_VM') {
            <b>Tipo veículo: </b>{{ element.tipoVeiculo }}<br />
            <b>Tipo motorista: </b>{{ element.tipoMotorista }}
          } @else if (column.keyColumn == 'custoExtra_HK') {
            <b>Hora: </b>{{ element.custoHoraExtra_formatado }}<br />
            <b>KM: </b>{{ element.custokmExtra_formatado }}
          } @else if (column.keyColumn == 'infoTariff') {
            <b>Perimetro urbano: </b
            >{{ element.perimetroUrbano == 'S' ? 'Sim' : 'Não' }}<br />
            <b>Standard: </b>{{ element.standard == 'S' ? 'Sim' : 'Não' }}
          } @else if (column.keyColumn == 'infoTariffPage') {
            <b>Perimetro urbano: </b
            >{{ element.perimetroUrbano == 'S' ? 'Sim' : 'Não' }}<br />
            <b>Standard: </b>{{ element.standard == 'S' ? 'Sim' : 'Não' }}<br />
            <b>Fornecedor: </b>{{ element.fornecedor ?? '-' }}<br />
          } @else if (column.keyColumn == 'pageRoute') {
            <b>Origem: </b>{{ element.origem }}<br />
            <b>Destino: </b>{{ element.destino }}<br />
            <b>Perimetro urbano: </b
            >{{ element.perimetroUrbano == 'S' ? 'Sim' : 'Não' }}
          } @else if (column.keyColumn == 'pageCost') {
            <b>Custo: </b>{{ element.custo_formatado }}<br />
            <b>Hora: </b>{{ element.custoHoraExtra_formatado }}<br />
            <b>KM: </b>{{ element.custokmExtra_formatado }}
          } @else if (column.keyColumn == 'pageSupplier') {
            <b>Standard: </b>{{ element.standard == 'S' ? 'Sim' : 'Não' }}<br />
            <b>Fornecedor: </b>{{ element.fornecedor ?? '-' }}<br />
          } @else if (column.keyColumn == 'pageClient') {
            <b>Standard: </b>{{ element.standard == 'S' ? 'Sim' : 'Não' }}<br />
            <b>Fornecedor: </b>{{ element.fornecedor ?? '-' }}<br />
            <b>Cliente: </b>{{ element.cliente }}<br />
          } @else if (column.keyColumn == 'supplierInfos') {
            <b>Nome: </b>{{ element.nomeFantasia }}<br />
            <b>Cnpj: </b>{{ element.cnpj | cnpj }}<br />
          } @else if (column.keyColumn == 'pageTariffLocation') {
            <b>Origem</b><br />
            Cidade: {{ element.cidadeOrigem }}<br />
            Estado: {{ element.estadoOrigem }}<br />
            <b>Destino</b><br />
            Cidade: {{ element.cidadeDestino }}<br />
            Estado: {{ element.estadoDestino }}
          } @else if (column.keyColumn == 'pageTariffLocationOrigin') {
            <b>Cidade: </b>{{ element.cidadeOrigem }}<br />
            <b>Estado: </b>{{ element.estadoOrigem }}<br />
          } @else if (column.keyColumn == 'pageTariffLocationDestination') {
            <b>Cidade: </b>{{ element.cidadeDestino }}<br />
            <b>Estado: </b>{{ element.estadoDestino }}
          } @else if (column.keyColumn == 'pageDate') {
            <b>Início: </b>{{ element.dataInicio }}<br />
            <b>Fim: </b>{{ element.dataFinal }}<br />
          } @else {
            {{ element[column.key] }}
          }
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      [ngClass]="checkSelect(row)"
      *matRowDef="let row; columns: displayedColumns"
      (click)="selectItemEvent(row)"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}

<!--    <ng-container *ngFor="let column of columns;" matColumnDef="{{column.keyColumn}}">-->
<!--      <th mat-header-cell *matHeaderCellDef> {{ column.description }} </th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        @if (column.keyColumn == 'action') {-->
<!--          <button mat-flat-button class="btn-tg w-1/5" >-->
<!--            Editar-->
<!--          </button>-->
<!--        } @else {-->
<!--          {{element[column.key]}}-->
<!--        }-->
<!--      </td>-->
<!--    </ng-container>-->
